export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Underground mining technicians and operators, shift bosses and supervisors, foremen, mining engineers, junior geomechanics and ventilation engineers, surveyors and planners, and advanced mining engineering students.',
  ],
  [
    'Content depth?',
    'From fundamentals to professional-level underground operations: mine layout and access, mining methods, ground support, drilling and blasting, ventilation and services, haulage, hoisting and safety.',
  ],
  [
    'Format?',
    'Technical reference material in professional PDF files with instant access. It is not software, a simulator, editable spreadsheets or a course with a certificate.',
  ],
  [
    'Does it replace mine procedures or regulations?',
    "No. It is technical reference material. It does not replace your mine's procedures, local mining regulations or the judgement of qualified and authorized personnel.",
  ],
  [
    'International?',
    "Yes. Based on internationally used concepts and terminology; always follow your mine's procedures, local mining regulations and manufacturer instructions.",
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
